export function assertType(obj, key, type = 'string') {
    if (!obj[key] || typeof obj[key] !== type) {
        throw new Error(`Missing or invalid "${key}" param`);
    }
}
export function hasParamsLength(params, length) {
    return Array.isArray(params)
        ? params.length === length
        : Object.keys(params).length === length;
}
export function methodEndsWith(method, expected, separator = '_') {
    const split = method.split(separator);
    return (split[split.length - 1].trim().toLowerCase() ===
        expected.trim().toLowerCase());
}
//# sourceMappingURL=misc.js.map